import { Component, OnDestroy, OnInit } from '@angular/core';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { AccountService } from '../services/account/account.service';
import { IncentiveConfig } from '../models/incentiveConfig';

declare var $ : any;
@Component({
  selector: 'app-incentive-config',
  templateUrl: './incentive-config.component.html',
  styleUrls: ['./incentive-config.component.css']
})
export class IncentiveConfigComponent implements OnInit, OnDestroy {

  selectedTab:String="accountTab";
  userTypes:any[]=[{id:"DIGITAL_EYE_MITRA",name:"Digital EyeMitra"},{id:"REGULAR_EYE_MITRA",name:"Regular EyeMitra"}];
  userTypeId:any = null;

  termsAndConditionRules: any[] = [];
  accounts: any[] = []; incentiveConfig = null; accountId = null;
  incentiveCategories: any[] =
    [
      {
        id: "ON_SIGNUP",
        value: "On Signup"
      },
      {
        id: "ON_REFRACTION_USE",
        value: "On Refraction Use"
      },
      {
        id: "ON_RECHARGE",
        value: "On Recharge"
      },
      {
        id: "RECHARGE_ELIGIBILITY",
        value: "Recharge Eligibility"
      }
    ];

  resetIncentiveConfig() {
    if(this.selectedTab=="accountTab"){
      this.incentiveConfig = {
        accountId: null,
        status: true,
        isIncentiveSchemeAvailable: true,
        incentiveEligibility: {
          hasRestrictedDuration: true,
          refractionUnitUsage: 30,
          refractionUnitUsageInDays: 45
        },
        isReferralSchemeAvailable: false, //making default value false
        eligibilityForReferral: {
          refractionUnitToBeUsed: null,
          maxUserReferral: 4,
          maxReferralRechargeBonus: null,
        },
        config: []
      };
    }
    else if(this.selectedTab=="userTypeTab"){
      this.incentiveConfig = {
        userType: null,
        status: true,
        isIncentiveSchemeAvailable: true,
        incentiveEligibility: {
          hasRestrictedDuration: true,
          refractionUnitUsage: 30,
          refractionUnitUsageInDays: 45
        },
        isReferralSchemeAvailable: false, //making default value false
        eligibilityForReferral: {
          refractionUnitToBeUsed: null,
          maxUserReferral: 4,
          maxReferralRechargeBonus: null,
        },
        config: []
      };
    }
  }

  getIncentiveConfigByAccountId() {
    this.termsAndConditionRules = [];
    this.resetIncentiveConfig();
    if (this.accountId > 0) {
      this.accountService.getIncentiveConfigByAccountId(this.accountId)
        .subscribe(response => {
          //if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response != null) {
            this.incentiveConfig = response;
            // if (this.incentiveConfig != null && this.incentiveConfig.config != null
            //   && this.incentiveConfig.config.length > 0) {
            //   this.incentiveConfig.config.forEach(element => {
            //     if (element.status) {
            //       this.termsAndConditionRules.push(
            //         {
            //           id: element.incentiveRuleName,
            //           value: element.incentiveRuleName
            //         });
            //     }
            //   });
            // }
            this.updateTermsAndConditions();
          }
          //}
          else {
            //this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }

  getIncentiveConfigByUserType() {
    this.termsAndConditionRules = [];
    this.resetIncentiveConfig();
    if (this.userTypeId != null) {
      this.accountService.getUserTypeIncentiveConfigByUserType(this.userTypeId)
        .subscribe(response => {
          if (response.data != null && response.data.length>0) {
            this.incentiveConfig = response.data[0];
            this.updateTermsAndConditions();
          }
          else {
            this.foruscareService.showNotification("No Incentive Configuration Available", "danger");
          }
        });
    }
  }

  addNewRow() {
    if (this.validateIncentiveForm()) {

      // this.termsAndConditionRules = [];
      // if (this.incentiveConfig != null && this.incentiveConfig.config != null &&
      //   this.incentiveConfig.config.length > 0) {
      //   this.incentiveConfig.config.forEach(element => {
      //     if (element.status) {
      //       this.termsAndConditionRules.push(
      //         {
      //           id: element.incentiveRuleName,
      //           value: element.incentiveRuleName
      //         });
      //     }
      //   });
      // }

      this.updateTermsAndConditions();

      // this.resetIncentiveConfig();
      if (this.incentiveConfig.config == null || this.incentiveConfig.config.length == 0) {
        this.incentiveConfig.config = [];
      }
      this.incentiveConfig.config.unshift(new IncentiveConfig());
    }
  }

  updateTermsAndConditions() {
    this.termsAndConditionRules = [];
    if (this.incentiveConfig != null && this.incentiveConfig.config != null &&
      this.incentiveConfig.config.length > 0) {
      this.incentiveConfig.config.forEach(element => {
        if (element.status) {
          this.termsAndConditionRules.push(
            {
              id: element.incentiveRuleName,
              value: element.incentiveRuleName
            });
        }
      });
    }
  }

  removeRow(index) {
    let ruleInUse = false;
    if (this.incentiveConfig != null && this.incentiveConfig.config != null && this.incentiveConfig.config.length > 0) {
      if (this.incentiveConfig.config[index] != null && this.incentiveConfig.config[index].id) {
        let ruleNameToDelete = this.incentiveConfig.config[index].incentiveRuleName;
        if (ruleNameToDelete != null && ruleNameToDelete.trim().length > 0) {
          this.incentiveConfig.config.forEach(element => {
            if (element.termsAndConditions != null && element.termsAndConditions.length > 0) {
              element.termsAndConditions.forEach(rulename => {
                if (rulename != null && rulename.trim().toLowerCase() == ruleNameToDelete.trim().toLowerCase()) {
                  ruleInUse = true;
                }
              });
            }
          });
        }
      }
    }
    if (ruleInUse) {
      this.foruscareService.showNotification("This rule is used in another one. Deletion is not possible", "danger");
    }
    else {
      if (this.incentiveConfig.config[index] != null && this.incentiveConfig.config[index].id == null) {
        this.incentiveConfig.config.splice(index, 1);
        this.updateTermsAndConditions();
      }
      else {
        this.incentiveConfig.config[index].status = !this.incentiveConfig.config[index].status;
      }
    }
  }

  constructor(private foruscareService: ForuscareService, private accountService: AccountService) { }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  validateIncentiveForm() {

    if (this.incentiveConfig != null && this.incentiveConfig.config != null && this.incentiveConfig.config.length > 0) {
      var rechargeEligibility = this.incentiveConfig.config.filter(function (itrObj, index) {
        return itrObj.incentiveCategory == "RECHARGE_ELIGIBILITY";
      });
      if (rechargeEligibility != null && rechargeEligibility.length > 1) {
        this.foruscareService.showNotification("Recharge Eligibility : Cannot add more than one rule", "danger");
        return false;
      }
    }

    if (this.incentiveConfig.isIncentiveSchemeAvailable &&
      this.incentiveConfig.incentiveEligibility.refractionUnitUsage == null) {
      this.foruscareService.showNotification("Incentive & Referral Eligibility : Fill Refraction Units", "danger");
      return false;
    }
    if (this.incentiveConfig.incentiveEligibility.hasRestrictedDuration &&
      this.incentiveConfig.incentiveEligibility.refractionUnitUsageInDays == null) {
      this.foruscareService.showNotification("Incentive & Referral Eligibility : Fill no. of Days", "danger");
      return false;
    }
    if (this.incentiveConfig.isReferralSchemeAvailable &&
      this.incentiveConfig.eligibilityForReferral.refractionUnitToBeUsed == null) {
      this.foruscareService.showNotification("Incentive & Referral Eligibility : Fill no. of Prescriptions", "danger");
      return false;
    }
    if (this.incentiveConfig.isReferralSchemeAvailable && this.incentiveConfig.eligibilityForReferral.maxUserReferral == null) {
      this.foruscareService.showNotification("Incentive & Referral Eligibility : Fill Max User Referrals", "danger");
      return false;
    }

    var valueArr = this.incentiveConfig.config.map(function (item) {
      return item.incentiveRuleName.trim().toLowerCase();
    });
    var isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx
    });

    if (isDuplicate) {
      this.foruscareService.showNotification("Incentive rule name should be unique", "danger");
      return false;
    }

    // if (this.incentiveConfig.isReferralSchemeAvailable &&
    //   this.incentiveConfig.eligibilityForReferral.maxReferralRechargeBonus == null) {
    //   this.foruscareService.showNotification("Incentive & Referral Eligibility : Fill Referral Bonus", "danger");
    //   return false;
    // }
    var result = true;
    if (this.incentiveConfig.config != null && this.incentiveConfig.config.length > 0) {
      this.incentiveConfig.config.forEach(element => {
        if (element.incentiveRuleName == null || element.incentiveRuleName.trim().length == 0) {
          this.foruscareService.showNotification("Please enter incentive rule name", "danger");
          result = false;
        }
        switch (element.incentiveCategory) {
          case "ON_SIGNUP":
            if (element.refractionCreditUnit == null && element.payoutToUser == null) {
              this.foruscareService.showNotification("On Signup : Fill either Refraction credit or Payout to user", "danger");
              result = false;
            }
            break;
          case "ON_REFRACTION_USE":
            if (element.refractionUsageInUnit == null && element.payoutToUser == null && !element.isConditionOnly) {
              this.foruscareService.showNotification("On Refraction Use : Fill either Refraction Usage or Payout to user", "danger");
              result = false;
            }
            if (element.onlyForReferredUser && element.payoutToReferredUser == null && !element.isConditionOnly) {
              this.foruscareService.showNotification("On Refraction Use : Fill Payout for referred user", "danger");
              result = false;
            }
            break;
          case "ON_RECHARGE":
            if (element.onlyForReferredUser && element.payoutToReferredUser == null && !element.isConditionOnly) {
              this.foruscareService.showNotification("On Recharge : Fill Payout for referred user", "danger");
              result = false;
            }
            if (element.rechargeType == "UNIT") {
              if (element.minRefractionRechargeUnit != null && element.maxRefractionRechargeUnit != null && element.minRefractionRechargeUnit > element.maxRefractionRechargeUnit) {
                this.foruscareService.showNotification("On Recharge : Min Refraction Unit can not be greater than Max Refraction Unit", "danger");
                result = false;
              }
            }
            if (element.rechargeType == "VALUE") {
              if (element.minRefractionRechargeCredit != null && element.maxRefractionRechargeCredit != null && element.minRefractionRechargeCredit > element.maxRefractionRechargeCredit) {
                this.foruscareService.showNotification("On Recharge : Min Refraction Credit can not be greater than Max Refraction Credit", "danger");
                result = false;
              }
            }
            if (element.payoutType == "PERCENTAGE" && (element.maxPayoutAmount == null || element.maxPayoutAmount == 0) && !element.isConditionOnly) {
              this.foruscareService.showNotification("On Recharge : Enter valid Max Payout Amount", "danger");
              result = false;
            }
            break;
        }
      });
    }
    return result;
  }
  saveIncentiveConfig() {
    if (this.validateIncentiveForm()) {
      if(this.selectedTab=="accountTab"){
      this.incentiveConfig.accountId = this.accountId;
      this.accountService.addOrUpdateIncentiveConfig(this.incentiveConfig)
        .subscribe(response => {
          //if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response != null) {
            //this.incentiveConfig = response.data;
            this.foruscareService.showNotification("Saved successfully", "success");
          }
          //}
          else {
            //this.foruscareService.showNotification(response.message, "danger");
          }
        });
      }
      else if(this.selectedTab=="userTypeTab"){
        this.incentiveConfig.userType = this.userTypeId;
        this.accountService.addOrUpdateUserTypeIncentiveConfig(this.incentiveConfig)
          .subscribe(response => {
            if (response.errorCode == 200) {
              //this.incentiveConfig = response.data;
              this.foruscareService.showNotification("Saved successfully", "success");
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          });
      }
    }
  }
  toggleTopBar(id){
    this.selectedTab=id;
    switch(id){
      case 'accountTab':
        $('#accountTab').css('background','#598496');
        $('#userTypeTab').css('background','#D3D3D3');
        this.userTypeId = null;
        break;
      case 'userTypeTab':
        $('#accountTab').css('background','#D3D3D3');
        $('#userTypeTab').css('background','#598496');
        this.accountId = null;
        break;
      default:
        $('#accountTab').css('background','#598496');
        $('#userTypeTab').css('background','#D3D3D3');
        this.userTypeId = null;
    }
  }

  ngOnInit() {
    $('.content-wrapper').css('padding-top','0px'); // set top bar
    this.toggleTopBar("accountTab");
    this.getAvailableAccounts();
    console.log($(".page-topbar"));
  }

  ngOnDestroy(): void {
    $('.content-wrapper').css('padding-top','30px');
  }

}
